import { render, staticRenderFns } from "./RoadMapSection.vue?vue&type=template&id=31d8aef0&scoped=true"
import script from "./RoadMapSection.vue?vue&type=script&lang=js"
export * from "./RoadMapSection.vue?vue&type=script&lang=js"
import style0 from "./RoadMapSection.vue?vue&type=style&index=0&id=31d8aef0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8aef0",
  null
  
)

export default component.exports